// extracted by mini-css-extract-plugin
export default {"masonryGrid":"BoxNoteCard_masonryGrid__K9Ldi","masonryColumn":"BoxNoteCard_masonryColumn__wUcZ6"};